import { useState, type FormEvent } from 'react';

import useDashboardWidgetMutations from '@/features/dashboard/hooks/useDashboardWidgetMutations';
import type { WidgetId } from '@/features/dashboard/registry';

import { APP_CATALOG } from './catalog';
import { mergeAppLauncherConfig, type AppLauncherConfig } from './config';

export default function AppLauncherSettingsForm({
  widgetId,
  config,
  onSaved,
  formId,
}: {
  widgetId: WidgetId;
  config: Record<string, unknown>;
  onSaved: () => void;
  formId: string;
}) {
  const mutations = useDashboardWidgetMutations();
  const initial = mergeAppLauncherConfig(config as Partial<AppLauncherConfig>);
  const [enabled, setEnabled] = useState<Record<string, boolean>>(initial.enabled);

  const toggle = (id: string) => {
    setEnabled((prev) => ({ ...prev, [id]: prev[id] === false }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (mutations.isPending) return;
    const values: AppLauncherConfig = { enabled };
    mutations.updateConfig(widgetId, values as unknown as Record<string, unknown>);
    onSaved();
  };

  return (
    <form id={formId} onSubmit={handleSubmit} className="flex flex-col gap-4">
      <fieldset className="flex flex-col gap-2">
        <legend className="text-xs font-medium tracking-wide text-(--text-secondary) uppercase">Visible apps</legend>
        <ul className="flex flex-col gap-1 rounded-md border border-(--border-subtle) bg-(--bg-surface) p-2">
          {APP_CATALOG.map((app) => (
            <li key={app.id}>
              <label className="flex cursor-pointer items-center gap-3 rounded px-2 py-1.5 text-sm text-(--text-primary) hover:bg-(--bg-surface-hover)">
                <input
                  type="checkbox"
                  checked={enabled[app.id] !== false}
                  onChange={() => toggle(app.id)}
                  className="h-4 w-4 rounded border-(--border-default) accent-(--accent-primary)"
                />
                <img src={app.icon} alt="" className="h-6 w-6 rounded object-contain" />
                <span className="min-w-0 flex-1 truncate">{app.name}</span>
              </label>
            </li>
          ))}
        </ul>
      </fieldset>
    </form>
  );
}
